import { useMemo, useRef } from 'react';

import type { CoinType } from '../../stores/cointype/CoinTypeStore';

import { Coin } from './Coin';
import { COINS_COUNT, SPACE_BETWEEN_COINS } from './constants';
import type { XY } from './types';

import './FlyingCoins.css';

export function FlyingCoins(props: {
  coinType: CoinType;
  amount: number | string;
  start: XY;
  end: XY;
  gif: string;
  size?: number;
  count?: number;
  hideLabel?: boolean;
  onLandingCoin?: () => void;
  onEnd?: () => void;
  fadeInDurationMs?: number;
  transitionDurationMs?: number;
}) {
  const count = Math.max(1, props.count ?? COINS_COUNT);
  const counter = useRef(count - 1);

  const coinEndHandler = () => {
    if (typeof props.onLandingCoin === 'function') {
      props.onLandingCoin();
    }

    if (counter.current > 0) {
      counter.current--;
    } else {
      if (typeof props.onEnd === 'function') {
        props.onEnd();
      }
    }
  };

  const coinsList = useMemo(
    () =>
      Array.from(new Array(count)).map((_, ind) => ({
        key: `${props.coinType}-${ind}`,
        timeOffset: ind * SPACE_BETWEEN_COINS,
      })),
    [props.coinType, count],
  );

  return (
    <div>
      {coinsList.map((coinObj) => {
        return (
          <Coin
            key={coinObj.key}
            end={props.end}
            fadeInDurationMs={props.fadeInDurationMs}
            gif={props.gif}
            size={props.size}
            start={props.start}
            timeOffset={coinObj.timeOffset}
            transitionDurationMs={props.transitionDurationMs}
            onEnd={coinEndHandler}
          />
        );
      })}
      {!props.hideLabel && (
        <div
          className={'fadeInOut text'}
          style={{
            left: `${props.start.x - 50}px`,
            top: `${props.start.y}px`,
            width: '100px',
            textAlign: 'center',
            position: 'fixed',
            fontWeight: '800',
            fontFamily: 'Outfit Variable',
            textTransform: 'uppercase',
            zIndex: 99999,
            animationDelay: `${(count / 2) * SPACE_BETWEEN_COINS}s`,
          }}
        >
          +{props.amount}
        </div>
      )}
    </div>
  );
}
